import React, { useState } from "react";
import styled from "styled-components";

import {
  CautionBanner,
  CheckboxInput,
  Label,
  ModalProps,
  VSpace,
  useVolatileCallback,
} from "@examspark/common-ui";
import { LabelText } from "@examspark/common-ui/dist/components/inputs/Label";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";

import PrintModal, { PrintModalRequest } from "../PrintModal";

const StyledCautionBanner = styled(CautionBanner)`
  border: solid 1px #ddd;
  border-radius: 0.5rem;
`;

const StyledCheckboxLabel = styled(Label)`
  & > input[type="checkbox"] {
    flex-grow: 0;
    order: -1;
  }

  & > ${LabelText} {
    text-transform: initial;
  }
`;

const StyledCheckboxes = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

const PrintPerformanceAssessmentModal = (
  props: ModalProps & {
    performanceAssessmentId: string;
    showStandards: boolean;
    workspace: string | null;
    username: string | null;
    workspaceId: string | null;
  },
) => {
  const [showStandards, setShowStandards] = useState(props.showStandards);

  const syncStateOnOpen = () => {
    setShowStandards(props.showStandards);
  };

  const onRequestPrint = useVolatileCallback(() => {
    const today = new Date();
    const { performanceAssessmentId, workspace, username, workspaceId } = props;

    return {
      action: "PrintPerformanceAssessment",
      params: {
        performanceAssessmentId,
        showStandards,
        workspace,
        username,
        workspaceId,
        copyrightYear: today.getFullYear().toString(),
        date: new Intl.DateTimeFormat("en-US").format(today),
      },
    } as PrintModalRequest;
  });

  if (!props.workspaceId) {
    return (
      <PrintModal
        title="Print Performance Assessment"
        size="small"
        requestPrintDisabled={true}
        {...props}
      >
        <PaddedBody>
          <VSpace>
            <StyledCautionBanner>
              We could not authorize you to print this performance assessment.
            </StyledCautionBanner>
          </VSpace>
        </PaddedBody>
      </PrintModal>
    );
  }

  return (
    <PrintModal
      title="Print Performance Assessment"
      size="small"
      onRequestPrint={onRequestPrint}
      onAfterOpen={syncStateOnOpen}
      {...props}
    >
      <PaddedBody>
        <VSpace>
          <StyledCautionBanner>
            This is a preview of a feature in development.
          </StyledCautionBanner>
          <StyledCheckboxes>
            <StyledCheckboxLabel label="Include aligned standards" layout="row">
              <CheckboxInput
                checked={showStandards}
                onChange={({ checked }) => {
                  setShowStandards(checked);
                }}
              />
            </StyledCheckboxLabel>
          </StyledCheckboxes>
        </VSpace>
      </PaddedBody>
    </PrintModal>
  );
};

export default PrintPerformanceAssessmentModal;
